import { httpClient } from '../network/httpclient/HttpClientFactory';

const login = param => httpClient.post(`/admin/login`, param).then(res => res.data);

const logout = () => httpClient.get(`/admin/logout`).then(res => res.data);

export default {
    login,
    logout
};
